module.exports = __webpack_public_path__ + "static/media/edit.842c79e5.svg";